import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, Typography } from '@mui/material';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';
import { InputKit } from '../../../components/UI';

export const CreateManager = ({
  onSubmit,
}: {
  onSubmit: (v: FieldValues) => void;
}) => {
  const methods = useForm({
    resolver: zodResolver(
      z.object({
        email: z
          .string({ required_error: 'Email is required' })
          .refine(
            value => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value),
            'Invalid email address'
          ),
      })
    ),
  });

  return (
    <FormProvider {...methods}>
      <Typography
        sx={{
          fontSize: '14px',
          color: '#344054',
          fontWeight: 'bold',
          marginBottom: '6px',
        }}
      >
        Email
      </Typography>
      <InputKit name='email' placeholder='Add member by email' />
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        gap={'24px'}
        marginTop='32px'
      >
        <Button
          sx={{
            maxWidth: '126px',
            width: '100%',
            fontSize: '14px',
            color: '#655C68',
            lineHeight: '17px',
            borderColor: '#E3DDE6',
          }}
          variant='outlined'
        >
          Cancel
        </Button>
        <Button
          sx={{
            background: '#3293DB',
            color: '#fff',
            maxWidth: '126px',
            width: '100%',
            fontSize: '14px',
            lineHeight: '17px',
          }}
          variant='contained'
          onClick={methods.handleSubmit(onSubmit)}
        >
          Done
        </Button>
      </Box>
    </FormProvider>
  );
};
